module.exports = __webpack_public_path__ + "static/media/car-calendar-blue.7d636594.svg";